module.exports = __webpack_public_path__ + "img/14.14251676.png";